const ProductMore = (props: { className?: string }) => (
  <svg width={40} height={40} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" className={props.className}>
    <path d="M16 18H12V22H16V18Z" className="fill-white" />
    <path d="M22 18H18V22H22V18Z" fill="#E25317" />
    <path d="M28 18H24V22H28V18Z" className="fill-white" />
  </svg>
);
export default ProductMore;
